(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ozzy-lounge-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initCalendars = (scope) => {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('[data-oz-calendar]').forEach((calendar) => {
      if (calendar.dataset.initialized === 'true') return;
      const section = calendar.closest('[data-oz-events-section]');
      const dayGrid = calendar.querySelector('[data-oz-days]');
      const monthLabel = calendar.querySelector('[data-oz-month]');
      const eventList = section && section.querySelector('[data-oz-event-list]');
      if (!section || !dayGrid || !monthLabel || !eventList) return;
      calendar.dataset.initialized = 'true';

      let eventItems = Array.from(eventList.querySelectorAll('[data-oz-event]'));
            // ISO dates sort chronologically, regardless of the theme editor block order.
      eventItems.sort((a, b) => (a.getAttribute('data-date') || '9999-99-99').localeCompare(b.getAttribute('data-date') || '9999-99-99'));
      const listEnd = eventList.querySelector('[data-oz-no-events]');
      eventItems.forEach((item) => eventList.insertBefore(item, listEnd));
let validEvents = eventItems.map((item) => ({
        element: item,
        date: item.getAttribute('data-date') || ''
      })).filter((event) => /^\d{4}-\d{2}-\d{2}$/.test(event.date));

      const listTitle = eventList.querySelector('[data-oz-list-title]');
      const eventCount = eventList.querySelector('[data-oz-count]');
      const emptyState = eventList.querySelector('[data-oz-no-events]');
      const getBaliToday = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Makassar', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date()).reduce((result, part) => {
        if (part.type !== 'literal') result[part.type] = part.value;
        return result;
      }, {});
      let baliToday = getBaliToday();
      let year = Number(baliToday.year);
      let month = Number(baliToday.month) - 1;
      let selectedDate = '';

      const monthKey = () => year + '-' + String(month + 1).padStart(2, '0');
      const monthName = () => new Intl.DateTimeFormat('en', { month: 'long', year: 'numeric' }).format(new Date(year, month, 1));

      const renderEvents = () => {
        const key = monthKey();
        const todayKey = baliToday.year + '-' + baliToday.month + '-' + baliToday.day;
        const matchesList = (date) => date.slice(0, 7) === key && (selectedDate ? date === selectedDate : date >= todayKey);
        const visible = validEvents.filter((event) => matchesList(event.date));
        eventItems.forEach((item) => {
          const date = item.getAttribute('data-date') || '';
          item.hidden = !matchesList(date);
        });
        if (listTitle) listTitle.textContent = selectedDate ? 'Events on ' + new Intl.DateTimeFormat('en', { month: 'long', day: 'numeric' }).format(new Date(year, month, Number(selectedDate.slice(8, 10)))) : 'Events in ' + monthName();
        if (eventCount) eventCount.textContent = visible.length + (visible.length === 1 ? ' event' : ' events') + (selectedDate ? ' on this day' : ' this month');
        if (emptyState) emptyState.hidden = visible.length > 0;
      };

      const renderCalendar = () => {
        monthLabel.textContent = monthName();
        dayGrid.replaceChildren();
        const firstWeekday = new Date(year, month, 1).getDay();
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        const monthEvents = validEvents.filter((event) => event.date.slice(0, 7) === monthKey());
        const eventDates = new Set(monthEvents.map((event) => event.date));
        const todayKey = baliToday.year + '-' + baliToday.month + '-' + baliToday.day;

        for (let i = 0; i < firstWeekday; i += 1) {
          const blank = document.createElement('span');
          blank.className = 'oz-calendar__blank';
          blank.setAttribute('aria-hidden', 'true');
          dayGrid.appendChild(blank);
        }
        for (let day = 1; day <= daysInMonth; day += 1) {
          const key = year + '-' + String(month + 1).padStart(2, '0') + '-' + String(day).padStart(2, '0');
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'oz-calendar__day';
          button.setAttribute('role', 'gridcell');
          button.setAttribute('aria-pressed', selectedDate === key ? 'true' : 'false');
          const eventTotal = monthEvents.filter((event) => event.date === key).length;
          const labelDate = new Intl.DateTimeFormat('en', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' }).format(new Date(year, month, day));
          button.setAttribute('aria-label', labelDate + (eventTotal ? ', ' + eventTotal + (eventTotal === 1 ? ' event' : ' events') : ', no events'));
          if (eventDates.has(key)) button.classList.add('has-events');
          if (key === todayKey) button.classList.add('is-today');
          if (selectedDate === key) button.classList.add('is-selected');
          const number = document.createElement('span');
          number.textContent = String(day);
          button.appendChild(number);
          button.addEventListener('click', () => {
            selectedDate = selectedDate === key ? '' : key;
            renderCalendar();
            renderEvents();
          });
          dayGrid.appendChild(button);
        }
        const usedCells = firstWeekday + daysInMonth;
        for (let i = usedCells; i < 42; i += 1) {
          const blank = document.createElement('span');
          blank.className = 'oz-calendar__blank';
          blank.setAttribute('aria-hidden', 'true');
          dayGrid.appendChild(blank);
        }
        renderEvents();
      };

      calendar.querySelector('[data-oz-prev]').addEventListener('click', () => {
        month -= 1;
        if (month < 0) { month = 11; year -= 1; }
        selectedDate = '';
        renderCalendar();
      });
      calendar.querySelector('[data-oz-next]').addEventListener('click', () => {
        month += 1;
        if (month > 11) { month = 0; year += 1; }
        selectedDate = '';
        renderCalendar();
      });
      renderCalendar();
      const endpoint = section.dataset.ozFeed;
      let syncing = false;
      const status = section.querySelector('[data-oz-sync-status]');
      const make = (tag, className, text) => {
        const node = document.createElement(tag);
        if (className) node.className = className;
        if (text !== undefined) node.textContent = text;
        return node;
      };
      const formatTime = value => new Intl.DateTimeFormat('en', { timeZone: 'Asia/Makassar', hour: 'numeric', minute: '2-digit', hour12: true }).format(new Date(value));
      const icon = category => {
        const wrap = make('span', 'oz-event-icon');
        wrap.setAttribute('aria-hidden', 'true');
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('viewBox', '0 0 32 32'); svg.setAttribute('fill', 'none');
        const shapes = /dance|bachata|salsa/i.test(category)
          ? [['circle',{cx:10,cy:6,r:2.5,fill:'currentColor'}],['circle',{cx:23,cy:8,r:2.5,fill:'#E31F31'}],['path',{d:'m5 10 5 2 5-3 3-5M10 12l-1 8m0-4 6 3 3 8M9 20l-4 7',stroke:'currentColor','stroke-width':2.2,'stroke-linecap':'round'}],['path',{d:'m16 10 6 3 5-1M22 13l-2 6 6 3H15l5-3m-1 3-2 6m7-6 3 6',stroke:'#E31F31','stroke-width':2,'stroke-linecap':'round'}]]
          : /sport|football/i.test(category)
          ? [['circle',{cx:16,cy:16,r:12,stroke:'currentColor','stroke-width':1.7}],['path',{d:'m16 10 5.7 4.1-2.2 6.7h-7l-2.2-6.7L16 10Z',fill:'currentColor'}],['path',{d:'m16 10-.1-6M21.7 14.1l5.7-1.8m-7.9 8.5 3.5 4.8m-10.5-4.8L9 25.6m1.3-11.5-5.7-1.8',stroke:'currentColor','stroke-width':1.5}]]
          : [['rect',{x:5,y:7,width:22,height:21,rx:3,stroke:'currentColor','stroke-width':1.8}],['path',{d:'M5 13h22M11 4v6m10-6v6m-10 8h3m4 0h3m-10 5h3',stroke:'currentColor','stroke-width':1.8,'stroke-linecap':'round'}]];
        shapes.forEach(([tag, attributes]) => { const node = document.createElementNS('http://www.w3.org/2000/svg',tag); Object.entries(attributes).forEach(([key,value]) => node.setAttribute(key,String(value))); svg.appendChild(node); });
        wrap.appendChild(svg); return wrap;
      };
      const makeArticle = event => {
        const article = make('article','oz-lounge-event');
        article.dataset.ozEvent = ''; article.dataset.date = event.date;
        article.dataset.googleEventId = event.id;
        const date = new Date(event.date + 'T12:00:00+08:00');
        article.appendChild(make('div','oz-lounge-event-date',new Intl.DateTimeFormat('en-GB',{timeZone:'Asia/Makassar',day:'2-digit',month:'short'}).format(date)));
        const copy = make('div','oz-lounge-event__copy');
        copy.appendChild(make('p','oz-kicker',event.category || section.dataset.ozEventLabel));
        const heading = make('h4','oz-event-title');
        heading.append(icon(event.category || ''),make('span','',event.title)); copy.appendChild(heading);
        let time = event.allDay ? section.dataset.ozAllday : formatTime(event.start);
        if (!event.allDay && /dance|party|music/i.test(event.category)) time += '–' + formatTime(event.end);
        copy.appendChild(make('p','oz-lounge-event__time',time + ' · Bali time (UTC+8)'));
        if (event.description) copy.appendChild(make('p','',event.description));
        const link = make('a','oz-lounge-text-link',section.dataset.ozBookLabel + ' ↗');
        try { const url = new URL(event.link || section.dataset.ozBooking); if (url.protocol === 'https:') { link.href = url.href; copy.appendChild(link); } } catch {}
        article.appendChild(copy); return article;
      };
      const applyFeed = payload => {
        if (!payload || payload.timezone !== 'Asia/Makassar' || !Array.isArray(payload.events)) throw new Error('Invalid event feed');
        if (payload.events.some(event => !event || !/^\d{4}-\d{2}-\d{2}$/.test(event.date) || typeof event.title !== 'string' || !Number.isFinite(Date.parse(event.start)) || !Number.isFinite(Date.parse(event.end)))) throw new Error('Invalid event');
        const next = payload.events.map(makeArticle);
        eventItems.forEach(item => item.remove());
        eventItems = next;
        validEvents = next.map(item => ({element:item,date:item.dataset.date}));
        next.forEach(item => eventList.insertBefore(item,emptyState));
        renderCalendar();
      };
      const syncCalendar = async () => {
        if (!endpoint || syncing || !calendar.isConnected || document.hidden) return;
        syncing = true;
        try {
          const response = await fetch(endpoint,{signal:AbortSignal.timeout(15000),credentials:'omit'});
          if (!response.ok) throw new Error('Calendar unavailable');
          const payload = await response.json();
          applyFeed(payload);
          if (status) status.hidden = true;
        } catch {
          if (status) { status.textContent = section.dataset.ozUnavailable; status.hidden = false; }
        } finally { syncing = false; }
      };
      if (endpoint) {
        syncCalendar();
        const syncTimer = setInterval(() => {
          if (!calendar.isConnected) { clearInterval(syncTimer); document.removeEventListener('visibilitychange',syncCalendar); return; }
          syncCalendar();
        },300000);
        document.addEventListener('visibilitychange',syncCalendar);
      }

      const refreshDate = () => {
        if (!calendar.isConnected) {
          clearInterval(dateTimer);
          document.removeEventListener('visibilitychange', refreshDate);
          return;
        }
        const nextToday = getBaliToday();
        if (nextToday.year + nextToday.month + nextToday.day !== baliToday.year + baliToday.month + baliToday.day) {
          baliToday = nextToday;
          renderCalendar();
        }
      };
      const dateTimer = setInterval(refreshDate, 60000);
      document.addEventListener('visibilitychange', refreshDate);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCalendars(document), { once: true });
  } else {
    initCalendars(document);
  }
  document.addEventListener('shopify:section:load', (event) => initCalendars(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
